import { type ExpenseMileageConfigurationConstructor } from '@webapp/modules/expense/entities/ExpenseMileageConfiguration'
import { mapMileageRatePresetApiModel } from './mapMileageRatePresetApiModel'
import { type ExpenseMileageConfigurationApiModel } from '../api-models/ExpenseMileageConfigurationApiModel'

export const mapExpenseMileageConfigurationApiModel = (
  apiModel: ExpenseMileageConfigurationApiModel
): ExpenseMileageConfigurationConstructor => ({
  forcePresetRates: apiModel.force_preset_rates,
  taxType: apiModel.tax_type,
  defaultMileagePreset: apiModel.default_mileage_preset
    ? mapMileageRatePresetApiModel(apiModel.default_mileage_preset)
    : null,
})
